import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from '@fortawesome/free-solid-svg-icons';
const PhoneIcon = () => {
  return (
    <FontAwesomeIcon icon={faPhone}/>
  )
}

export default PhoneIcon